import BorderBox6 from './main'
export default function (Vue) {
  Vue.component(BorderBox6.name, BorderBox6)
}



// WEBPACK FOOTER //
// ./src/components/border/border-box-6/index.js